import DrugScreenBanner from './DrugScreenBanner';

export default DrugScreenBanner;
